module.exports = __webpack_public_path__ + "static/media/Niveau_elN13_2_1015823.2b160b5f.png";